import { cn } from "@/lib/utils";
import { MapPin, CalendarDays, Clock } from "lucide-react";

const estadoStyles = {
  "Venta disponible":
    "bg-accent/15 text-accent border-accent/40",
  "Últimos lugares":
    "bg-primary/10 text-primary dark:text-accent border-primary/30 dark:border-accent/40",
  Próximamente:
    "bg-muted text-muted-foreground border-border",
  Agotado:
    "bg-destructive/10 text-destructive border-destructive/30",
};

/**
 * Tarjeta pública de evento (sólo informativa · sin botón Comprar).
 */
export default function EventoPublicoCard({ evento, testId }) {
  const badge = estadoStyles[evento.estado] || estadoStyles["Próximamente"];

  return (
    <article
      data-testid={testId}
      className={cn(
        "group rounded-2xl border hairline bg-card p-6",
        "shadow-soft transition-all duration-300",
        "hover:-translate-y-0.5 hover:shadow-elevated",
        "flex flex-col gap-4",
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h3 className="font-heading text-xl text-foreground leading-snug">
            {evento.nombre}
          </h3>
        </div>
        <span
          className={cn(
            "shrink-0 px-3 py-1 rounded-full text-[11px] font-medium border",
            badge,
          )}
        >
          {evento.estado}
        </span>
      </div>

      <ul className="flex flex-col gap-2 text-sm text-muted-foreground">
        <li className="flex items-center gap-2">
          <CalendarDays className="w-4 h-4 text-accent" strokeWidth={1.6} />
          <span>{evento.fecha}</span>
        </li>
        <li className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-accent" strokeWidth={1.6} />
          <span>{evento.hora}</span>
        </li>
        <li className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-accent" strokeWidth={1.6} />
          <span>{evento.lugar}</span>
        </li>
      </ul>
    </article>
  );
}
